import { render, staticRenderFns } from "./LoyaltyTransaction.vue?vue&type=template&id=022ab081&scoped=true&"
import script from "./LoyaltyTransaction.vue?vue&type=script&lang=ts&"
export * from "./LoyaltyTransaction.vue?vue&type=script&lang=ts&"
import style0 from "./LoyaltyTransaction.vue?vue&type=style&index=0&id=022ab081&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022ab081",
  null
  
)

export default component.exports